export const BtnStyle = {
  fontFamily: "Roboto, Arial",
  borderRadius: '10px 5px 10px 5px',
  color: "white",
  backgroundColor: "#ba8b59",
  "&:hover, &:active": { backgroundColor: "#cad3da", color: '#ba8b59' },
};
